import { render, staticRenderFns } from "./ManagerHeader.vue?vue&type=template&id=80228330&scoped=true&"
import script from "./ManagerHeader.vue?vue&type=script&lang=js&"
export * from "./ManagerHeader.vue?vue&type=script&lang=js&"
import style0 from "./ManagerHeader.vue?vue&type=style&index=0&id=80228330&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80228330",
  null
  
)

export default component.exports